/*
* @Author: Alexander.Vangelov@vonage.com
* @Date: 2020-07-01 15:56:51
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2020-07-01 16:01:23
*/

require('./button.scss');

let btn = document.createElement('button');
btn.className = 'vgip-button';

module.exports = btn;
